import { relations, sql } from 'drizzle-orm'
import { pgEnum, pgTable, uniqueIndex } from 'drizzle-orm/pg-core'
import {
  getBaseFields,
  getBaseIndexes,
  getIdReference,
  getNullableIdReference,
} from '../common/utils'
import { discountCodes } from './discountCode'
import { users } from './user'
import { visits } from './visit'

export const recommendedServiceEnum = pgEnum('recommended_service', [
  'nuohous',
  'ilp_syvapuhdistus',
  'iv_puhdistus',
  'rannien_puhdistus',
  'katon_pesu_pinnoitus',
  'ei_mikaan',
])

// The technician's one-tap answer at visit completion when no free-text
// upsell was written. 'ei_mikaan' is stored too so the share of visits with
// no cross-sell potential is measurable. The email + voucher automation hangs
// off this row (notifications.entityId), never off the visit update.
export const visitRecommendations = pgTable(
  'visit_recommendations',
  {
    ...getBaseFields(),
    visitId: getIdReference(() => visits.id),
    recommendedByUserId: getIdReference(() => users.id),
    service: recommendedServiceEnum().notNull(),
    // Personal voucher minted when the recommendation email is sent.
    discountCodeId: getNullableIdReference(() => discountCodes.id),
  },
  (table) => [
    ...getBaseIndexes('visit_recommendations', table),
    uniqueIndex('visit_recommendations_visit_id_unique_idx')
      .on(table.visitId)
      .where(sql`${table.deletedAt} IS NULL`),
  ],
)

export const visitRecommendationsRelations = relations(
  visitRecommendations,
  ({ one }) => ({
    visit: one(visits, {
      fields: [visitRecommendations.visitId],
      references: [visits.id],
    }),
    recommendedBy: one(users, {
      fields: [visitRecommendations.recommendedByUserId],
      references: [users.id],
    }),
    discountCode: one(discountCodes, {
      fields: [visitRecommendations.discountCodeId],
      references: [discountCodes.id],
    }),
  }),
)
